<script setup lang="ts">
defineEmits<{
  onClick: [event: MouseEvent];
}>();

withDefaults(
  defineProps<{
    icon: string;
    disabled?: boolean;
    compact?: boolean;
    ariaLabel?: string;
    customClass?: string;
  }>(),
  {
    disabled: false,
    compact: false,
    ariaLabel: undefined,
    customClass: undefined,
  }
);
</script>

<template>
  <Button
    outlined
    plain
    size="small"
    :ariaLabel="ariaLabel"
    :class="['af-button-thin border-none text-sm text-gray-500', { 'h-7 w-10': compact }, customClass]"
    :disabled
    :icon
    @click="$emit('onClick', $event)"
  />
</template>
